import React, { createContext, useContext, useEffect, useState } from 'react';

interface GlobalControlsContextProps {
  toggleOverflow: (key: string, state: boolean) => void;
  scrollLocked: boolean;
}

const GlobalControlsContext = createContext<GlobalControlsContextProps | undefined>(undefined);

interface WithGlobalControlsPropsBase {}

type WithGlobalControlsProps = React.PropsWithChildren<WithGlobalControlsPropsBase>;

let scrollLockY = 0;
let scrollLocked = false;

function lockScroll() {
  if (scrollLocked) return;
  scrollLocked = true;
  scrollLockY = window.scrollY || window.pageYOffset;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollLockY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflow = 'hidden';
  document.body.style.width = '100%';
}

function unlockScroll() {
  if (!scrollLocked) return;
  scrollLocked = false;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflow = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollLockY);
}

export function WithGlobalControls(props: WithGlobalControlsProps) {
  const [overflowState, setOverflowState] = useState<{ [key: string]: boolean }>({});
  const scrollLocked = Object.values(overflowState).includes(true);

  function toggleOverflow(key: string, state: boolean) {
    setOverflowState(prevState => ({ ...prevState, [key]: state }));
  }

  useEffect(() => {
    if (scrollLocked) lockScroll();
    else unlockScroll();
  }, [overflowState]);

  return (
    <GlobalControlsContext.Provider value={{ toggleOverflow, scrollLocked }}>
      {props.children}
    </GlobalControlsContext.Provider>
  );
}

export function useGlobalControls() {
  const context = useContext(GlobalControlsContext);
  if (context === undefined) {
    throw new Error('useGlobalControls must be used within a GlobalControlsProvider');
  }
  return context;
}
